
  import ipxRuntime$pEyiIfVxYqbHj9_04axpuV6WoCZiF0u6KpkWzsRQ6Cw from '/opt/carify/website/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$pEyiIfVxYqbHj9_04axpuV6WoCZiF0u6KpkWzsRQ6Cw, defaults: {} }
    }
  }
